export const ehrAction = {
  changeActiveEHRJobsTab: (state, action) => {
    state.activeEHRJobsTab = action.payload;
  },
};
